import { useQuery } from '@tanstack/react-query';
import { dashboardQueries } from '../data/dashboard.queries';
import type { DashboardQueryParams, PaginatedQueryParams } from '../data/dashboard.service';

export const useDashboardKpis = (params: DashboardQueryParams) => {
    return useQuery(dashboardQueries.kpis(params));
};

export const useDashboardAnalytics = (params: DashboardQueryParams) => {
    return useQuery(dashboardQueries.analytics(params));
};

export const useDashboardMerchants = (params: PaginatedQueryParams) => {
    return useQuery(dashboardQueries.merchants(params));
};

export const useDashboardTransactions = (params: PaginatedQueryParams) => {
    return useQuery(dashboardQueries.transactions(params));
};

export const useDashboardInvoices = (params: PaginatedQueryParams) => {
    return useQuery(dashboardQueries.invoices(params));
};

export const useDashboardRenewals = (params: PaginatedQueryParams) => {
    return useQuery(dashboardQueries.renewals(params));
};

export const useDashboardAds = (params: DashboardQueryParams) => {
    return useQuery(dashboardQueries.ads(params));
};
